import { Button, List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import DonutScore from "../DonutScore";
/* -----------------Globals--------------- */

type Props = {
	title: string;
	description: string;
	score: number;
	cta: string;
	numericId: number;
	appFont: string;
	isWeb: boolean;
	handleNavigation: (numericId: number) => void;
};
export const PracticeTestCardListItem = ({
	title,
	description,
	score,
	cta,
	numericId,
	isWeb,
	handleNavigation,
}: Props) => {
	const theme = useAppTheme();
	return (
		<List.Item
			onPress={isWeb ? () => handleNavigation(numericId) : undefined}
			title={title}
			description={description}
			titleNumberOfLines={2}
			titleStyle={theme.fonts.titleSmall}
			descriptionStyle={theme.fonts.bodySmall}
			style={{
				paddingLeft: 16,
				paddingRight: 16,
			}}
			left={(p) => (
				<List.Icon
					{...p}
					style={{
						marginLeft: 0,
					}}
					icon={() => (
						<DonutScore
							variant="progress"
							distribution={[score, 100 - score]}
							score={score}
							radius={24}
							innerRadius={20}
							textVariant="labelMedium"
						/>
					)}
				/>
			)}
			right={(p) => (
				<List.Icon
					{...p}
					icon={() => (
						<Button onPress={() => handleNavigation(numericId)} mode="text">
							{cta}
						</Button>
					)}
				/>
			)}
		/>
	);
};
